module.exports = vendor_aa3164967fb7bbe5dda7;


//////////////////
// WEBPACK FOOTER
// external "vendor_aa3164967fb7bbe5dda7"
// module id = 5
// module chunks = 6